import { PlatformEnum } from '@vacationtracker/shared/data/platforms'

/**
 * Stamped as `authFlow` on every event from the new sign-in and sign-up pages. The old pages send
 * no `authFlow`, so reporting separates the two by whether it is set. A later redesign gets a new
 * value rather than reusing this one.
 */
export const AUTH_FLOW = 'new-signup-signin-redesign-2026-10'

/**
 * `authFlow` for the sign-up steps both pages lead into. Those steps cannot tell which page sent
 * the visitor, but the build flag that picks the page can, so with it off they add nothing.
 */
export const sharedStepAuthFlow = (): { authFlow?: typeof AUTH_FLOW } => (process.env.REACT_APP_USE_NEW_SIGNIN_SIGNUP === 'true' ? { authFlow: AUTH_FLOW } : {})

/**
 * The closing step of the sign-up funnel, so a flow can be measured end to end by event name
 * alone: BUTTON_CLICKED → ERROR / CANCELED / SUCCESS.
 *
 * Spelled out rather than built from the platform name, so every event this product sends can
 * be found by searching for its literal. It lives here rather than inside `new-signup/` because
 * the funnel closes in the shared company-creation container, outside the flagged folder.
 *
 * This sits alongside `SIGNUP_COMPLETED` rather than replacing it: existing dashboards read
 * that, and it carries the platform as a property. Only the new flow sends it, since only the
 * new page opens the funnel it closes.
 */
export const SIGNUP_SUCCESS_EVENT: Record<string, string> = {
  [PlatformEnum.Slack]: 'SIGNUP_WITH_SLACK_SUCCESS',
  [PlatformEnum.Microsoft]: 'SIGNUP_WITH_MICROSOFT_SUCCESS',
  [PlatformEnum.Google]: 'SIGNUP_WITH_GOOGLE_SUCCESS',
  [PlatformEnum.Email]: 'SIGNUP_WITH_EMAIL_SUCCESS',
}
